var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"flex bg-gray-100 hover:bg-gray-200 rounded-lg transition p-1 vst_tabs"},[_c('nav',{ref:"nav",staticClass:"flex space-x-2"}),_vm._t("nav")],2)]),_vm._t("default"),_c('div',{ref:"body",staticClass:"vst-tabs mt-2 bg-white"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }